const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/contact/validators/action-validators.js